import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, status: String, orderStatus: String, revision: String, homeUrl: String }

  connect() {
    this.timer = setInterval(() => this.refresh(), 15000)
    this.onVisibility = () => { if (!document.hidden) this.refresh() }
    document.addEventListener("visibilitychange", this.onVisibility)
  }

  async refresh() {
    if (document.hidden || this.loading) return
    this.loading = true
    this.abort = new AbortController()
    try {
      const response = await fetch(this.urlValue, {headers: {Accept: "application/json"}, cache: "no-store", signal: this.abort.signal})
      if (!response.ok) return
      const result = await response.json()
      if (!result.visible) { window.location.replace(this.homeUrlValue); return }
      if (result.status !== this.statusValue || (result.order_status || "") !== this.orderStatusValue || result.revision !== this.revisionValue) window.location.reload()
    } catch (error) {
      // При временной потере сети следующий опрос повторится без потери страницы.
    } finally { this.loading = false }
  }

  disconnect() {
    clearInterval(this.timer)
    this.abort?.abort()
    document.removeEventListener("visibilitychange", this.onVisibility)
  }
}
